import { string as yupString } from 'yup'
import NumberSchema from 'yup/lib/number'
import StringSchema from 'yup/lib/string'
import { TFunction } from 'i18next'
import { Maybe } from 'yup/lib/types'

export interface IInput {
  name: string,
  placeholder: string,
  value: string,
  validationSchema: NumberSchema|StringSchema<Maybe<string>>,
}

const firstNameShape = (t: TFunction): StringSchema => yupString()
  .label(t('form.fields.firstName'))
  .required(t('form.validation.firstName.required'))

const lastNameShape = (t: TFunction): StringSchema => yupString()
  .label(t('form.fields.lastName'))
  .required(t('form.validation.lastName.required'))

const phoneShape = (t: TFunction): StringSchema => yupString()
  .label(t('form.fields.phone'))
  .required(t('form.validation.phone.required'))

const emailShape = (t: TFunction): StringSchema => yupString()
  .label(t('form.fields.email'))
  .email(t('form.validation.email.email'))
  .required(t('form.validation.email.required'))

const lastNameInput = (t: TFunction): IInput => ({
  value: '',
  placeholder: t('form.fields.lastName'),
  name: 'lastName',
  validationSchema: lastNameShape(t),
})

const firstNameInput = (t: TFunction): IInput => ({
  value: '',
  placeholder: t('form.fields.firstName'),
  name: 'firstName',
  validationSchema: firstNameShape(t),
})

const phoneInput = (t: TFunction): IInput => ({
  value: '',
  placeholder: t('form.fields.phone'),
  name: 'phone',
  validationSchema: phoneShape(t),
})

const emailInput = (t: TFunction): IInput => ({
  value: '',
  placeholder: t('form.fields.email'),
  name: 'email',
  validationSchema: emailShape(t),
})

export default (t: TFunction): IInput[] => [
  lastNameInput(t),
  firstNameInput(t),
  phoneInput(t),
  emailInput(t),
]
